import type { DesignItem } from './types';

export interface PrintAreaSize {
  width: number;
  height: number;
}

export interface AddItemOptions {
  placement?: 'as-provided' | 'print-area-center';
}

/** Fit down (never up) and center an item in print-area coordinate space. */
export function centerItemInPrintArea<T extends DesignItem>(item: T, area: PrintAreaSize): T {
  const areaWidth = Math.max(1, Number(area.width) || 1);
  const areaHeight = Math.max(1, Number(area.height) || 1);
  const sourceWidth = Math.max(1, Number(item.width) || 1);
  const sourceHeight = Math.max(1, Number(item.height) || 1);
  const scale = Math.min(1, (areaWidth * 0.8) / sourceWidth, (areaHeight * 0.8) / sourceHeight);
  const width = Math.max(1, Math.round(sourceWidth * scale));
  const height = Math.max(1, Math.round(sourceHeight * scale));

  return {
    ...item,
    width,
    height,
    left: Math.max(0, Math.round((areaWidth - width) / 2)),
    top: Math.max(0, Math.round((areaHeight - height) / 2)),
  };
}
